import { render, staticRenderFns } from "./AppInProgress.vue?vue&type=template&id=4ede77d2&scoped=true&"
import script from "./AppInProgress.vue?vue&type=script&lang=js&"
export * from "./AppInProgress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ede77d2",
  null
  
)

export default component.exports